import format from 'date-fns/format';
export const bookingDateFormat = (value: string, dateFormat?: string) => {
    try {
        const date = new Date(value);
        return format(date, dateFormat || 'yyyy-MM-dd');
    } catch (error) {
        return value;
    }
};
